import { createContext } from 'react';

import type {
  ActionCard,
  FolioMode,
  FolioStreamMessage,
  GuideStep,
  PageContext,
  PageContextTransition,
} from '@/hooks/use-folio-stream';

export interface PausedFolioConversation {
  readonly id: string;
  readonly projectId: string | null;
  readonly label: string;
}

export interface FolioSessionStateValue {
  readonly messages: readonly FolioStreamMessage[];
  readonly isStreaming: boolean;
  readonly isBusy: boolean;
  readonly currentMode: FolioMode | null;
  readonly error: string | null;
  readonly conversationProjectId?: string | null;
  readonly pendingContextTransition?: PageContextTransition | null;
  readonly pausedConversation?: PausedFolioConversation | null;
}

export interface FolioSessionCommandsValue {
  readonly pageContext: PageContext;
  readonly sendMessage: (text: string, pageContextOverride?: PageContext) => void;
  readonly stopStreaming: () => void;
  readonly confirmActionCard: (action: ActionCard, guideStep?: GuideStep) => Promise<void>;
  readonly retryLastMessage: () => void;
  readonly setPageContext: (pageContext: PageContext | null) => void;
  readonly conversationId: string | null;
  readonly loadConversation: (
    conversationId: string,
    conversationProjectId?: string | null,
  ) => Promise<void>;
  readonly clearConversation: () => void;
  readonly resumePausedConversation?: () => Promise<void>;
  readonly dismissPausedConversation?: () => void;
}

export type FolioSessionContextValue = FolioSessionStateValue & FolioSessionCommandsValue;

export const FolioSessionStateContext = createContext<FolioSessionStateValue | null>(null);
export const FolioSessionCommandsContext = createContext<FolioSessionCommandsValue | null>(null);
export const FolioSessionContext = createContext<FolioSessionContextValue | null>(null);
